import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class Steps extends Component {
    static propTypes = {
        os: PropTypes.string.isRequired,
        isTablet: PropTypes.bool,
        onClose: PropTypes.func.isRequired,
    };

    render() {
        const title = <div className={styles.title}>{_('Instalar webapp')}</div>;

        const close = (
            <div className={styles.close} onClick={this.props.onClose}>
                {_('Cerrar')}
            </div>
        );

        const appName = settings.app.name;

        if (this.props.os === 'Android') {
            return (
                <div className={styles.android}>
                    <div className={styles.arrowUp} />
                    {title}
                    <div className={styles.steps}>
                        <div>
                            {_('Abrí el menú')}
                            <div className={styles.circleIcon}>
                                <i className='material-icons'>more_vert</i>
                            </div>
                        </div>
                        <div>{_("Seleccioná 'Agregar al Escritorio / Inicio'")}</div>
                        <div>
                            {_('Confirmá el nombre y buscá el ícono de {{appName}} en tu pantalla de inicio', {
                                appName,
                            })}
                        </div>
                    </div>
                    {close}
                </div>
            );
        }

        if (this.props.os === 'iOS') {
            return (
                <div className={classNames(styles.ios, { [styles.ipad]: this.props.isTablet })}>
                    {this.props.isTablet && <div className={styles.arrowUp} />}
                    {title}
                    <div className={styles.steps}>
                        <div>
                            {_("Presioná el botón 'Compartir'")} <div className={styles.iosShare} />
                        </div>
                        <div>
                            {_("Seleccioná 'Añadir a Pantalla de Inicio'")}
                            <div className={styles.icon}>
                                <i className='material-icons'>add_box</i>
                            </div>
                        </div>
                        <div>
                            {_('Confirmá el nombre y buscá el ícono de {{appName}} en tu pantalla de inicio', {
                                appName,
                            })}
                        </div>
                    </div>
                    {close}
                    {!this.props.isTablet && <div className={styles.arrowDown} />}
                </div>
            );
        }
    }
}
